/* eslint-disable no-case-declarations */
import initialState from './initialState';

const licenseReducer = (state = initialState.license, action) => {
    switch (action.type) {
        case 'LICENSE_SUCCESS':
            return {
                ...state,
                all: action.licenses
            };
        case 'SET_LICENSE_SUCCESS':
            const activeLicense = state.all.filter(
                license => action.id === license.ID
            )[0];

            return {
                ...state,
                active: activeLicense
            };
        case 'LOGOUT_SUCCESS':
            return {
                active: {},
                all: []
            };
        default:
            return state;
    }
};

export default licenseReducer;
